import { render } from "./FormatPrice.vue?vue&type=template&id=929b1efc&scoped=true&ts=true"
import script from "./FormatPrice.vue?vue&type=script&lang=ts"
export * from "./FormatPrice.vue?vue&type=script&lang=ts"

import "./FormatPrice.vue?vue&type=style&index=0&id=929b1efc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929b1efc"]])

export default __exports__